import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeMenu } from "../utils/appSlice";
import { Link, useSearchParams } from "react-router-dom";
import CommentsContainer from "./CommentsContainer";
import LiveChat from "./LiveChat";
import { API_KEY, YOUTUBE_VIDEO_DETAILS } from "../utils/constants";
import { CiBellOn } from "react-icons/ci";
import { TfiDownload } from "react-icons/tfi";
import { PiShareFatLight } from "react-icons/pi";
import { PiCurrencyCircleDollar } from "react-icons/pi";
import { PiDotsThreeBold } from "react-icons/pi";
import { BiLike, BiDislike } from "react-icons/bi";

const WatchPage = () => {
  let [searchParams] = useSearchParams();
  const [video, setVidoe] = useState();
  // console.log("searchParams watchPage", searchParams);
  const dispatch = useDispatch();
  const searchResults = useSelector((store) => store.searchResults.response);
  const apiData = useSelector((store) => store.apiData.response);

  const getVideoDetails = async () => {
    const data = await fetch(
      YOUTUBE_VIDEO_DETAILS + searchParams.get("v") + "&key=" + API_KEY
    );
    const json = await data.json();
    console.log("json single video:>> ", json.items);
    setVidoe(json.items);
  };

  useEffect(() => {
    dispatch(closeMenu());
    getVideoDetails();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="md:flex ">
      <div className="p-2 md:pl-16  mt-16 md:mt-24 ">
        <div className=" md:w-[888px]">
          <div >
            <iframe
              className="rounded-lg md:rounded-2xl w-full  h-60 md:w-[888px] md:h-[500px]"
            
              src={
                "https://www.youtube.com/embed/" +
                searchParams.get("v") +
                "?autoplay=1"
              }
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
              allowFullScreen
            ></iframe>
          </div>
          <div className="text-xl my-2 font-semibold ">
            {video && video[0].snippet.localized.title}
          </div>
          <div className="md:flex justify-between items-center ">
            <div className="my-2 flex  items-center font-bold">
              <img
                className="w-9 h-9 m-1  rounded-full object-cover"
                src={video && video[0].snippet.thumbnails.default.url}
                alt="Channel Icon"
              />
              {video && video[0].snippet.channelTitle}
            </div>
            <div className=" flex md:flex justify-between md:mx-2">
              <button className="hover:bg-gray-800 bg-black text-white h-9  text-sm md:ml-5 rounded-full p-2 px-3 md:flex justify-center items-center mr-3">
                <CiBellOn className="hidden md:inline-block mr-2" size={18} />
                Subscribe
              </button>
              <button className=" hover:bg-gray-200 bg-gray-100 rounded-l-full h-9 text-sm px-3 md:flex justify-center items-center border border-gray-200">
                <BiLike className="inline-block mr-2" size={18} />
                {video && video[0].statistics.likeCount}
              </button>
              <button className="hover:bg-gray-200 bg-gray-100 rounded-r-full h-9 text-sm px-3 flex justify-center items-center md:mr-3">
                <BiDislike className="inline-block ml-2" size={18} />
              </button>
              <button className="hover:bg-gray-200 bg-gray-100 rounded-full h-9 text-sm px-3 flex  justify-center items-center mr-3">
                <PiShareFatLight className="inline-block mr-2" size={18} />
                Share
              </button>
              <button className="hidden hover:bg-gray-200 bg-gray-100 rounded-full h-9 px-3  text-sm md:flex  justify-center items-center mr-3 ">
                <TfiDownload className="inline-block mr-2" size={18} />
                Download
              </button>
              <button className="hidden hover:bg-gray-200 bg-gray-100 rounded-full  h-9 px-3  text-sm md:flex justify-center items-center mr-3">
                <PiCurrencyCircleDollar
                  className="inline-block mr-2"
                  size={18}
                />
                Thanks
              </button>
              <button className=" hidden hover:bg-gray-200 bg-gray-100 rounded-full p-2  w-9 h-9 md:flex  justify-center  item-center">
                <PiDotsThreeBold className="inline-block " />
              </button>
            </div>
          </div>
          <div className="  my-2 bg-gray-100 p-2 rounded-xl  ">
            <div className="font-bold text-sm">
              {video &&
                (video[0].statistics.viewCount >= 1000000
                  ? Math.round(video[0].statistics.viewCount / 1000000) + "M"
                  : video[0].statistics.viewCount >= 1000
                  ? Math.round(video[0].statistics.viewCount / 1000) + "k"
                  : video[0].statistics.viewCount)}{" "}
              views
            </div>
            <div className=" line-clamp-2 text-sm ">
              <div className=""> {video && video[0].snippet.description}</div>
             
            </div>
          </div>
        </div>
        <div className="" >
          <CommentsContainer />
        </div>
      </div>
      <div className="ml-5 p-2">
        <div className="hidden md:inline-block">
          <LiveChat />
        </div>

        <div className="hidden md:inline-block  mt-9 cursor-pointer">
          {searchResults &&
            searchResults.map((s) => (
              <Link key={s.id.videoId} to={"/watch?v=" + s.id.videoId}>
                <div className="flex items-start">
                  <div>
                    <img
                      className="m-2 rounded-lg w-48"
                      src={s.snippet.thumbnails.medium.url}
                      alt=""
                    />
                  </div>
                  <div className="w-60 m-2">
                    <p className="line-clamp-2 font-bold text-sm">{s.snippet.title}</p>
                    <p>{s.snippet.channelTitle}</p>
                  </div>
                </div>
              </Link>
            ))}
          {apiData &&
            apiData.map((s) => (
              <Link key={s.id} to={"/watch?v=" + s.id}>
                <div className="flex items-start">
                  <div>
                    <img
                      className="m-2 rounded-lg w-48"
                      src={s.snippet.thumbnails.medium.url}
                      alt=""
                    />
                  </div>
                  <div className="w-60 m-2">
                    <p className="line-clamp-2 font-bold text-sm">{s.snippet.title}</p>
                    <p>{s.snippet.channelTitle}</p>
                  </div>
                </div>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};

export default WatchPage;
